import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProposalRequestStatuses } from 'src/app/interfaces/proposal-request-statuses';
import { proposalRequestFileValidator } from 'src/app/validators/proposal-request-file-validator';

import { AddressForm } from './address-form';
import { ProposalRequestFileForm } from './proposal-request-file-form';
import { ProposalRequestLineItemForm } from './proposal-request-line-item.form';
import { ProposalRequestVendorForm } from './proposal-request-vendor-form';
import { QuickSourceProgressForm } from './quick-source-progress-form';
import { SiteForm } from './site-form';

export class ProposalRequestForm extends FormGroup<{
  id: FormControl<number | undefined>;
  CompanyId: FormControl<number | undefined>;
  SiteId: FormControl<number | undefined>;
  name: FormControl<string | undefined>;
  type: FormControl<string>;
  status: FormControl<ProposalRequestStatuses>;

  workAddress: FormControl<string | undefined>;
  workAddress2: FormControl<string | null>;
  workCity: FormControl<string | undefined>;
  workZip: FormControl<string | undefined>;
  SubNationalDivisionId: FormControl<number | undefined>;

  contactFirstName: FormControl<string | undefined>;
  contactLastName: FormControl<string | undefined>;
  contactPhoneExt: FormControl<string | null>;
  contactPhone: FormControl<string | undefined>;
  contactPhone2Ext: FormControl<string | null>;
  contactPhone2: FormControl<string | null>;
  contactEmail: FormControl<string | undefined>;
  instructions: FormControl<string | undefined>;
  multiLine: FormControl<boolean>;
  notify: FormControl<boolean>;

  statusDate: FormControl<Date | undefined>;
  startDate: FormControl<Date | undefined>;
  dueDate: FormControl<Date | undefined>;
  reminderDate: FormControl<Date | undefined>;
  releasedDate: FormControl<Date | undefined>;
  closedDate: FormControl<Date | undefined>;
  awardedDate: FormControl<Date | undefined>;
  cancelledDate: FormControl<Date | undefined>;

  Address: AddressForm;
  ProposalRequestFiles: FormArray<ProposalRequestFileForm>;
  Site: SiteForm;
  ProposalRequestLineItems: FormArray<ProposalRequestLineItemForm>;
  ProposalRequestVendors?: FormArray<ProposalRequestVendorForm>;
  QuickSourceProgresses: FormArray<QuickSourceProgressForm>;
}> {
  constructor() {
    const AddressFormGroup = new AddressForm();

    const {
      controls: { address1, city, state, zip }
    } = AddressFormGroup;

    address1.addValidators(Validators.required);
    city.addValidators(Validators.required);
    state.addValidators(Validators.required);
    zip.addValidators(Validators.required);

    super({
      id: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      CompanyId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      SiteId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      name: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      type: new FormControl<string>('QUICKSOURCE', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      status: new FormControl<ProposalRequestStatuses>('CREATED', {
        nonNullable: true,
        validators: [Validators.required]
      }),

      workAddress: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      workAddress2: new FormControl<string | null>(null),
      workCity: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      workZip: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      SubNationalDivisionId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),

      contactFirstName: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      contactLastName: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      contactPhoneExt: new FormControl<string | null>(null),
      contactPhone: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      contactPhone2Ext: new FormControl<string | null>(null),
      contactPhone2: new FormControl<string | null>(null),
      contactEmail: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      instructions: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      multiLine: new FormControl<boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      notify: new FormControl<boolean>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),

      statusDate: new FormControl<Date | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      startDate: new FormControl<Date | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      dueDate: new FormControl<Date | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      reminderDate: new FormControl<Date | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      releasedDate: new FormControl<Date | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      closedDate: new FormControl<Date | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      awardedDate: new FormControl<Date | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      cancelledDate: new FormControl<Date | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),

      Address: AddressFormGroup,

      ProposalRequestFiles: new FormArray<ProposalRequestFileForm>([], {
        validators: [proposalRequestFileValidator]
      }),
      Site: new SiteForm(),
      ProposalRequestLineItems: new FormArray<ProposalRequestLineItemForm>([]),
      QuickSourceProgresses: new FormArray<QuickSourceProgressForm>([])
    });
  }
}
